import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgRenderExternalModule } from './../svg-render-external/svg-render-external.module';
import { ChatBotService } from './chat-bot.component.service';
import { BotService } from './_bot/_bot.service';
import { ScrollBotContainerDirective } from './_bot/_bot.directive';
import { BotComponent } from './_bot/_bot.component';
import { ConversationComponent } from './conversation/conversation.component';
import { MessageComponent } from './message/message.component';
import { RenderCardHero } from './message/messageRenders/renderCardHero/renderCardHero.component';
import { RenderPlainText } from './message/messageRenders/renderPlainText/renderPlainText.component';
import { RenderUserPlainText } from './message/messageRenders/renderUserMessage/renderUserMessage.component';
import { RenderCardThumbnail } from './message/messageRenders/renderCardThumbnail/renderCardThumbnail.component';
import { RenderCardAdaptive } from './message/messageRenders/renderCardAdaptive/renderCardAdaptive.component';
import { RenderReconnectText } from './message/messageRenders/renderReconnectText/renderReconnectText.component';
import { AdaptiveRenderCta } from './message/messageRenders/renderCardAdaptive/adaptiveRenders/CTA/adaptiveRender-cta.component';
import { MarkdownToHtmlPipeModule } from '../../pipes/markdown/markdown.module';

@NgModule({
    imports: [
        CommonModule,
        SvgRenderExternalModule,
        MarkdownToHtmlPipeModule,
    ],
    declarations: [
        ScrollBotContainerDirective,
        BotComponent,
        ConversationComponent,
        MessageComponent,
        RenderCardHero,
        RenderPlainText,
        RenderUserPlainText,
        RenderCardThumbnail,
        RenderCardAdaptive,
        RenderReconnectText,
        AdaptiveRenderCta,
    ],
    exports: [
        BotComponent,
    ],
    providers: [
        ChatBotService,
        BotService,
    ],
})

export class ChatBotModule { }
